import React, { useState, useEffect } from 'react';

const API_URL = '/api/hiring';   // ← use proxy-relative path
const PHONE_NUMBER = '+97577248888'; // ST Motors phone number

function HiringViewer() {
  const [hiringVehicles, setHiringVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);               // ← ADD THIS LINE
  const [hoveredCard, setHoveredCard] = useState(null);
  const [showRatesModal, setShowRatesModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
const fetchHiringVehicles = async () => {
  setLoading(true);
  setError(null);

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  try {
    const apiUrl = process.env.REACT_APP_API_URL ;
    
    const res = await fetch(`${apiUrl}${API_URL}`, {
      signal: controller.signal,
      headers: {
        Accept: 'application/json',
        'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
      },
      mode: 'cors', // Changed from 'credentials: same-origin'
    });

    clearTimeout(timeoutId);

    if (!res.ok) {
      if (res.status === 401) throw new Error('Unauthorized – invalid or missing API key');
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const result = await res.json();

    if (result.success && Array.isArray(result.data)) {
      setHiringVehicles(result.data);
    } else {
      setError('Invalid response format from server');
    }
  } catch (err) {
    setError(
      err.name === 'AbortError'
        ? 'Request timed out'
        : err.message || 'Failed to load hiring vehicles'
    );
    console.error('Fetch error:', err);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchHiringVehicles();

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const openRatesModal = (vehicle) => {
    setSelectedVehicle(vehicle);
    setShowRatesModal(true);
  };

  const formatPrice = (price) => {
    if (!price) return 'Contact for pricing';
    return `Nu. ${price.toLocaleString()}`;
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
        color: '#C7B381',
        fontSize: 'clamp(1.5rem, 3vw, 2rem)',
        fontWeight: '300',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        Loading luxury collection...
      </div>
    );


  }
  if (error) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
        color: '#ff6b6b',
        textAlign: 'center',
        padding: '2rem',
      }}>
        <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠️ Error</h2>
        <p style={{ fontSize: '1.3rem', maxWidth: '600px' }}>{error}</p>
        <button
          onClick={fetchHiringVehicles}
          style={{
            marginTop: '2rem',
            padding: '1rem 2.5rem',
            background: '#C7B381',
            color: '#0F1419',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1.1rem',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </div>
    );
  }
  return (
    <>
      {/* Floating Call & WhatsApp Buttons */}
      <div style={{
        position: 'fixed',
        right: 'clamp(20px, 3vw, 30px)',
        bottom: 'clamp(20px, 3vw, 30px)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'clamp(12px, 2vw, 15px)',
        zIndex: 1000
      }}>
        <a
          href={`tel:${PHONE_NUMBER}`}
          style={{
            width: 'clamp(50px, 8vw, 60px)',
            height: 'clamp(50px, 8vw, 60px)',
            background: '#4CAF50',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 30px rgba(76, 175, 80, 0.4)',
            transition: 'all 0.3s',
            fontSize: 'clamp(1.5rem, 2.5vw, 1.8rem)',
            textDecoration: 'none'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.15)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          📞
        </a>

        <a
          href={`https://wa.me/${PHONE_NUMBER.replace(/[^0-9]/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: 'clamp(50px, 8vw, 60px)',
            height: 'clamp(50px, 8vw, 60px)',
            background: '#25D366',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 30px rgba(37, 211, 102, 0.4)',
            transition: 'all 0.3s',
            textDecoration: 'none'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.15)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <svg viewBox="0 0 24 24" width="clamp(28px, 5vw, 34px)" height="clamp(28px, 5vw, 34px)" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.198.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.884 3.088" />
          </svg>
        </a>
      </div>

      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
        color: '#E8E8E8',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        <div style={{
          padding: 'clamp(4rem, 8vw, 6rem) clamp(1rem, 3vw, 2rem) clamp(6rem, 10vw, 8rem)',
          maxWidth: '1600px',
          margin: '0 auto'
        }}>
          {/* Header + New Navigation */}
          <div style={{ textAlign: 'center', marginBottom: 'clamp(4rem, 8vw, 6rem)' }}>

            <h1 style={{
              fontSize: 'clamp(2.5rem, 6vw, 4rem)',
              fontWeight: '300',
              marginBottom: 'clamp(1rem, 2vw, 1.5rem)',
              color: '#FFFFFF',
              letterSpacing: '-0.01em'
            }}>
              Vehicle <span style={{ fontWeight: '600', color: '#C7B381' }}>Hiring</span>
            </h1>

            <p style={{
              fontSize: 'clamp(1rem, 2vw, 1.2rem)',
              color: '#B8B8B8',
              maxWidth: '700px',
              margin: '0 auto 2.5rem auto',
              lineHeight: '1.8',
              fontWeight: '300',
              padding: '0 1rem'
            }}>
              Explore our collections of EV for Hiring
            </p>
            <p style={{
              fontSize: 'clamp(1rem, 2vw, 1.2rem)',
              color: '#B8B8B8',
              maxWidth: '700px',
              margin: '0 auto 2.5rem auto',
              lineHeight: '1.8',
              fontWeight: '300',
              padding: '0 1rem'
            }}>
            </p>

            {/* New navigation links */}
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: 'clamp(1rem, 2.5vw, 1.5rem)',
              margin: 'clamp(1.5rem, 4vw, 2.5rem) auto',
              maxWidth: '800px'
            }}>

              <a
                href="/hiring-agreement-view"
                style={{
                  padding: 'clamp(0.9rem, 2vw, 1.1rem) clamp(1.8rem, 4vw, 2.5rem)',
                  background: 'rgba(199, 179, 129, 0.1)',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.4)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: 'clamp(0.95rem, 1.6vw, 1.05rem)',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.6rem'
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.2)';
                  e.currentTarget.style.borderColor = '#C7B381';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.1)';
                  e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.4)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                View Hiring Agreements
              </a>
            </div>

          </div>

          {/* Vehicle Grid */}
          {hiringVehicles.length > 0 && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(350px, 1fr))',
              gap: 'clamp(1.5rem, 3vw, 3rem)'
            }}>
              {hiringVehicles.map((vehicle) => (
                <div
                  key={vehicle._id}
                  onMouseEnter={() => setHoveredCard(vehicle._id)}
                  onMouseLeave={() => setHoveredCard(null)}
                  style={{
                    background: 'rgba(15, 20, 25, 0.6)',
                    border: '1px solid rgba(199, 179, 129, 0.15)',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    transform: hoveredCard === vehicle._id ? 'translateY(-12px)' : 'translateY(0)',
                    boxShadow: hoveredCard === vehicle._id
                      ? '0 32px 64px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(199, 179, 129, 0.3)'
                      : '0 8px 32px rgba(0, 0, 0, 0.3)'
                  }}
                >
                  {/* Image */}
                  <div style={{ position: 'relative', overflow: 'hidden', height: 'clamp(240px, 35vw, 280px)' }}>
                    <img
                      src={vehicle.imageURL}
                      alt={vehicle.carName}
                      onError={(e) => {
                        e.target.src = 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800';
                        e.target.alt = 'Fallback vehicle image';
                      }}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                        transform: hoveredCard === vehicle._id ? 'scale(1.1)' : 'scale(1)'
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      inset: 0,
                      background: hoveredCard === vehicle._id
                        ? 'linear-gradient(to top, rgba(15, 20, 25, 0.8) 0%, transparent 50%)'
                        : 'linear-gradient(to top, rgba(15, 20, 25, 0.6) 0%, transparent 50%)',
                      transition: 'all 0.4s'
                    }}></div>

                    {/* Car Number Badge */}
                    {vehicle.carNumber && (
                      <div style={{
                        position: 'absolute',
                        top: 'clamp(15px, 2vw, 20px)',
                        right: 'clamp(15px, 2vw, 20px)',
                        background: 'rgba(199, 179, 129, 0.95)',
                        color: '#0F1419',
                        padding: 'clamp(0.4rem, 1vw, 0.5rem) clamp(0.8rem, 1.5vw, 1rem)',
                        borderRadius: '20px',
                        fontSize: 'clamp(0.75rem, 1.3vw, 0.85rem)',
                        fontWeight: '600',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                        letterSpacing: '0.05em'
                      }}>
                        {vehicle.carNumber}
                      </div>
                    )}
                  </div>

                  {/* Content */}
                  <div style={{ padding: 'clamp(1.5rem, 3vw, 2.5rem)' }}>
                    <div style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)' }}>
                      <h3 style={{
                        fontSize: 'clamp(1.4rem, 2.5vw, 1.8rem)',
                        fontWeight: '400',
                        color: '#FFFFFF',
                        marginBottom: 'clamp(0.5rem, 1vw, 0.8rem)',
                        letterSpacing: '-0.01em'
                      }}>
                        {vehicle.carName}
                      </h3>
                      {vehicle.dailyRate && (
                        <div style={{
                          display: 'flex',
                          alignItems: 'baseline',
                          gap: '0.5rem',
                          flexWrap: 'wrap'
                        }}>
                          <div style={{
                            fontSize: 'clamp(1.3rem, 2.2vw, 1.6rem)',
                            color: '#C7B381',
                            fontWeight: '300'
                          }}>
                            {formatPrice(vehicle.dailyRate)}
                          </div>
                          <div style={{
                            fontSize: 'clamp(0.85rem, 1.5vw, 0.95rem)',
                            color: '#888',
                            fontWeight: '300'
                          }}>
                           + GST / day
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Quick Info */}
                    <div style={{
                      padding: 'clamp(1rem, 2vw, 1.5rem) 0',
                      borderTop: '1px solid rgba(199, 179, 129, 0.1)',
                      borderBottom: '1px solid rgba(199, 179, 129, 0.1)',
                      marginBottom: 'clamp(1rem, 2vw, 1.5rem)',
                      color: '#B8B8B8',
                      fontSize: 'clamp(0.85rem, 1.5vw, 0.9rem)',
                      lineHeight: '1.6'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                        <span style={{ color: '#888' }}>Security Deposit:</span>
                        <span style={{ color: '#C7B381', fontWeight: '500' }}>
                          {formatPrice(vehicle.securityDeposit)}
                        </span>
                      </div>
                      <div style={{ fontSize: 'clamp(0.8rem, 1.4vw, 0.85rem)', color: '#666', marginTop: '0.8rem' }}>
                        Multiple rate plans available
                      </div>
                    </div>

                    {/* Bookings Info */}
                    {vehicle.bookings && vehicle.bookings.length > 0 && (
                      <div style={{
                        background: 'rgba(199, 179, 129, 0.08)',
                        border: '1px solid rgba(199, 179, 129, 0.2)',
                        padding: 'clamp(0.7rem, 1.5vw, 0.9rem)',
                        borderRadius: '8px',
                        textAlign: 'center',
                        color: '#C7B381',
                        fontWeight: '500',
                        marginBottom: 'clamp(1rem, 2vw, 1.5rem)',
                        fontSize: 'clamp(0.85rem, 1.5vw, 0.95rem)'
                      }}>
                        {vehicle.bookings.length} Active Booking{vehicle.bookings.length > 1 ? 's' : ''}
                      </div>
                    )}

                    {/* Action Button */}
                    <button
                      onClick={() => openRatesModal(vehicle)}
                      style={{
                        width: '100%',
                        padding: 'clamp(1rem, 2vw, 1.2rem)',
                        background: '#C7B381',
                        color: '#0F1419',
                        border: 'none',
                        borderRadius: '8px',
                        fontWeight: '600',
                        fontSize: 'clamp(0.9rem, 1.7vw, 1rem)',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        letterSpacing: '0.02em'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#D4C599';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 179, 129, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#C7B381';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      Explore Rates
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {hiringVehicles.length === 0 && (
            <div style={{ textAlign: 'center', padding: 'clamp(100px, 15vw, 120px) clamp(1rem, 3vw, 2rem)', color: '#888' }}>
              <h2 style={{
                fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                marginBottom: 'clamp(1rem, 2vw, 1.5rem)',
                color: '#C7B381'
              }}>
                No vehicles available
              </h2>
              <p style={{ fontSize: 'clamp(1rem, 2vw, 1.3rem)' }}>
                Please check back later for our hiring collection
              </p>
            </div>
          )}

          {hiringVehicles.length === 0 && (
            <div style={{ textAlign: 'center', padding: 'clamp(100px, 15vw, 120px) clamp(1rem, 3vw, 2rem)', color: '#888' }}>
              <h2 style={{
                fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                marginBottom: 'clamp(1rem, 2vw, 1.5rem)',
                color: '#C7B381'
              }}>
                No vehicles available
              </h2>
              <p style={{ fontSize: 'clamp(1rem, 2vw, 1.3rem)' }}>
                Please check back later for our hiring collection
              </p>
            </div>
          )}

          {/* App Download CTA Section */}
          <div style={{
            marginTop: 'clamp(4rem, 8vw, 6rem)',
            padding: 'clamp(2.5rem, 5vw, 4rem)',
            background: 'linear-gradient(135deg, rgba(199, 179, 129, 0.1) 0%, rgba(199, 179, 129, 0.05) 100%)',
            border: '1px solid rgba(199, 179, 129, 0.2)',
            borderRadius: '16px',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              marginBottom: 'clamp(1rem, 2vw, 1.5rem)'
            }}>

            </div>
            <h2 style={{
              fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
              fontWeight: '400',
              color: '#FFFFFF',
              marginBottom: 'clamp(1rem, 2vw, 1.5rem)',
              letterSpacing: '-0.01em'
            }}>
              Discover <span style={{ fontWeight: '600', color: '#C7B381' }}>More Vehicles</span>
            </h2>
            <p style={{
              fontSize: 'clamp(1rem, 2vw, 1.2rem)',
              color: '#B8B8B8',
              maxWidth: '700px',
              margin: '0 auto clamp(2.5rem, 4vw, 3rem) auto',
              lineHeight: '1.8',
              fontWeight: '300',
              padding: '0 1rem'
            }}>
              There are more cars available in ST Motors hiring! Download our app to see all available vehicles and send us your booking request directly.
            </p>

            {/* App Store Buttons */}
            <div style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: 'clamp(1rem, 2.5vw, 1.5rem)',
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap'
            }}>
              {/* Google Play Store Button */}
              <a
                href="
https://play.google.com/store/apps/details?id=com.company.showroom" // Replace with actual Play Store link
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.8rem',
                  padding: 'clamp(1rem, 2vw, 1.2rem) clamp(1.8rem, 4vw, 2.5rem)',
                  background: 'rgba(199, 179, 129, 0.1)',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.3)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: 'clamp(0.95rem, 1.7vw, 1.05rem)',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  letterSpacing: '0.02em',
                  textDecoration: 'none',
                  minWidth: isMobile ? '100%' : 'auto',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.2)';
                  e.currentTarget.style.borderColor = '#C7B381';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 179, 129, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.1)';
                  e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.3)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <svg viewBox="0 0 24 24" width="clamp(24px, 4vw, 28px)" height="clamp(24px, 4vw, 28px)" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: 'clamp(0.65rem, 1.2vw, 0.75rem)', opacity: 0.8, fontWeight: '300' }}>GET IT ON</div>
                  <div style={{ fontSize: 'clamp(0.95rem, 1.7vw, 1.05rem)', fontWeight: '600' }}>Google Play</div>
                </div>
              </a>

              {/* Apple App Store Button */}
              <a
                href=" https://apps.apple.com/app/st-motors-ev/id6754755756" // Replace with actual App Store link
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.8rem',
                  padding: 'clamp(1rem, 2vw, 1.2rem) clamp(1.8rem, 4vw, 2.5rem)',
                  background: 'rgba(199, 179, 129, 0.1)',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.3)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: 'clamp(0.95rem, 1.7vw, 1.05rem)',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  letterSpacing: '0.02em',
                  textDecoration: 'none',
                  minWidth: isMobile ? '100%' : 'auto',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.2)';
                  e.currentTarget.style.borderColor = '#C7B381';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 179, 129, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.1)';
                  e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.3)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <svg viewBox="0 0 24 24" width="clamp(24px, 4vw, 28px)" height="clamp(24px, 4vw, 28px)" fill="currentColor">
                  <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
                </svg>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: 'clamp(0.65rem, 1.2vw, 0.75rem)', opacity: 0.8, fontWeight: '300' }}>Download on the</div>
                  <div style={{ fontSize: 'clamp(0.95rem, 1.7vw, 1.05rem)', fontWeight: '600' }}>App Store</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Rates Modal */}
      {showRatesModal && selectedVehicle && (
        <div
          onClick={() => setShowRatesModal(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000,
            padding: 'clamp(1rem, 2vw, 2rem)',
            overflowY: 'auto'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'linear-gradient(135deg, #1A1F2E 0%, #0F1419 100%)',
              border: '1px solid rgba(199, 179, 129, 0.3)',
              borderRadius: '16px',
              width: '100%',
              maxWidth: '900px',
              maxHeight: '90vh',
              overflowY: 'auto',
              boxShadow: '0 24px 48px rgba(0, 0, 0, 0.6)',
              margin: isMobile ? '0' : '2rem auto'
            }}
          >
            <div style={{ padding: 'clamp(1.5rem, 4vw, 2.5rem)' }}>
              {/* Header */}
              <div style={{ marginBottom: 'clamp(1.5rem, 3vw, 2rem)' }}>
                <h3 style={{
                  fontSize: 'clamp(1.6rem, 3vw, 2rem)',
                  color: '#C7B381',
                  marginBottom: 'clamp(0.5rem, 1vw, 0.8rem)',
                  fontWeight: '400',
                  letterSpacing: '-0.01em'
                }}>
                  Rental Rates
                </h3>
                <p style={{
                  color: '#B8B8B8',
                  fontSize: 'clamp(1rem, 2vw, 1.1rem)',
                  marginBottom: 'clamp(0.5rem, 1vw, 0.8rem)'
                }}>
                  {selectedVehicle.carName}
                </p>
                {selectedVehicle.carNumber && (
                  <div style={{
                    display: 'inline-block',
                    padding: 'clamp(0.4rem, 1vw, 0.5rem) clamp(0.8rem, 1.5vw, 1rem)',
                    background: 'rgba(199, 179, 129, 0.1)',
                    border: '1px solid rgba(199, 179, 129, 0.3)',
                    borderRadius: '20px',
                    color: '#C7B381',
                    fontSize: 'clamp(0.8rem, 1.4vw, 0.9rem)',
                    fontWeight: '600'
                  }}>
                    {selectedVehicle.carNumber}
                  </div>
                )}
              </div>

              {/* Vehicle Image */}
              {selectedVehicle.imageURL && (
                <div style={{
                  marginBottom: 'clamp(1.5rem, 3vw, 2rem)',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid rgba(199, 179, 129, 0.2)'
                }}>
                  <img
                    src={selectedVehicle.imageURL}
                    alt={selectedVehicle.carName}
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800';
                      e.target.alt = 'Fallback vehicle image';
                    }}
                    style={{
                      width: '100%',
                      height: isMobile ? '200px' : '300px',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              )}

              {/* Rate Cards Grid */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(240px, 1fr))',
                gap: 'clamp(1rem, 2vw, 1.5rem)',
                marginBottom: 'clamp(1.5rem, 3vw, 2rem)'
              }}>
                {/* Daily Rate */}
                {selectedVehicle.dailyRate && (
                  <div style={{
                    background: 'rgba(199, 179, 129, 0.05)',
                    border: '1px solid rgba(199, 179, 129, 0.2)',
                    borderRadius: '12px',
                    padding: 'clamp(1.5rem, 3vw, 2rem)',
                    transition: 'all 0.3s'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(199, 179, 129, 0.08)';
                      e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(199, 179, 129, 0.05)';
                      e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                    }}>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 1.3vw, 0.8rem)',
                      color: '#888',
                      marginBottom: 'clamp(0.5rem, 1vw, 0.8rem)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.1em',
                      fontWeight: '600'
                    }}>
                      Daily Rate
                    </div>
                    <div style={{
                      fontSize: 'clamp(1.5rem, 2.8vw, 2rem)',
                      color: '#C7B381',
                      fontWeight: '300',
                      marginBottom: 'clamp(0.3rem, 0.5vw, 0.5rem)'
                    }}>
                      {formatPrice(selectedVehicle.dailyRate)} + GST
                    </div>
                    <div style={{
                      fontSize: 'clamp(0.8rem, 1.4vw, 0.85rem)',
                      color: '#666'
                    }}>
                      per day
                    </div>
                  </div>
                )}

                {/* Monthly With Driver */}
                {selectedVehicle.monthlyWithDriver && (
                  <div style={{
                    background: 'rgba(199, 179, 129, 0.05)',
                    border: '1px solid rgba(199, 179, 129, 0.2)',
                    borderRadius: '12px',
                    padding: 'clamp(1.5rem, 3vw, 2rem)',
                    transition: 'all 0.3s'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(199, 179, 129, 0.08)';
                      e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(199, 179, 129, 0.05)';
                      e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                    }}>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 1.3vw, 0.8rem)',
                      color: '#888',
                      marginBottom: 'clamp(0.5rem, 1vw, 0.8rem)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.1em',
                      fontWeight: '600'
                    }}>
                      Monthly With Driver
                    </div>
                    <div style={{
                      fontSize: 'clamp(1.5rem, 2.8vw, 2rem)',
                      color: '#C7B381',
                      fontWeight: '300',
                      marginBottom: 'clamp(0.3rem, 0.5vw, 0.5rem)'
                    }}>
                      {formatPrice(selectedVehicle.monthlyWithDriver)} + GST
                    </div>
                    <div style={{
                      fontSize: 'clamp(0.8rem, 1.4vw, 0.85rem)',
                      color: '#666'
                    }}>
                      per month
                    </div>
                  </div>
                )}

                {/* Monthly Without Driver */}
                {selectedVehicle.monthlyWithoutDriver && (
                  <div style={{
                    background: 'rgba(199, 179, 129, 0.05)',
                    border: '1px solid rgba(199, 179, 129, 0.2)',
                    borderRadius: '12px',
                    padding: 'clamp(1.5rem, 3vw, 2rem)',
                    transition: 'all 0.3s'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(199, 179, 129, 0.08)';
                      e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(199, 179, 129, 0.05)';
                      e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                    }}>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 1.3vw, 0.8rem)',
                      color: '#888',
                      marginBottom: 'clamp(0.5rem, 1vw, 0.8rem)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.1em',
                      fontWeight: '600'
                    }}>
                      Monthly Without Driver
                    </div>
                    <div style={{
                      fontSize: 'clamp(1.5rem, 2.8vw, 2rem)',
                      color: '#C7B381',
                      fontWeight: '300',
                      marginBottom: 'clamp(0.3rem, 0.5vw, 0.5rem)'
                    }}>
                      {formatPrice(selectedVehicle.monthlyWithoutDriver)} + GST
                    </div>
                    <div style={{
                      fontSize: 'clamp(0.8rem, 1.4vw, 0.85rem)',
                      color: '#666'
                    }}>
                      per month
                    </div>
                  </div>
                )}

                {/* Yearly Without Driver */}
                {selectedVehicle.yearlyWithoutDriver && (
                  <div style={{
                    background: 'rgba(199, 179, 129, 0.05)',
                    border: '1px solid rgba(199, 179, 129, 0.2)',
                    borderRadius: '12px',
                    padding: 'clamp(1.5rem, 3vw, 2rem)',
                    transition: 'all 0.3s'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(199, 179, 129, 0.08)';
                      e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(199, 179, 129, 0.05)';
                      e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                    }}>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 1.3vw, 0.8rem)',
                      color: '#888',
                      marginBottom: 'clamp(0.5rem, 1vw, 0.8rem)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.1em',
                      fontWeight: '600'
                    }}>
                      Yearly Without Driver
                    </div>
                    <div style={{
                      fontSize: 'clamp(1.5rem, 2.8vw, 2rem)',
                      color: '#C7B381',
                      fontWeight: '300',
                      marginBottom: 'clamp(0.3rem, 0.5vw, 0.5rem)'
                    }}>
                      {formatPrice(selectedVehicle.yearlyWithoutDriver)} + GST
                    </div>
                    <div style={{
                      fontSize: 'clamp(0.8rem, 1.4vw, 0.85rem)',
                      color: '#666'
                    }}>
                      per year
                    </div>
                  </div>
                )}
              </div>

              {/* Security Deposit Card */}
              {selectedVehicle.securityDeposit && (
                <div style={{
                  background: 'rgba(199, 179, 129, 0.08)',
                  border: '1px solid rgba(199, 179, 129, 0.3)',
                  borderRadius: '12px',
                  padding: 'clamp(1.5rem, 3vw, 2rem)',
                  marginBottom: 'clamp(1.5rem, 3vw, 2rem)'
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '1rem'
                  }}>
                    <div>
                      <div style={{
                        fontSize: 'clamp(0.8rem, 1.4vw, 0.9rem)',
                        color: '#888',
                        marginBottom: '0.5rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.1em',
                        fontWeight: '600'
                      }}>
                        Security Deposit
                      </div>
                      <div style={{
                        fontSize: 'clamp(1.3rem, 2.5vw, 1.6rem)',
                        color: '#C7B381',
                        fontWeight: '400'
                      }}>
                        {formatPrice(selectedVehicle.securityDeposit)}
                      </div>
                    </div>
                    <div style={{
                      fontSize: 'clamp(0.8rem, 1.4vw, 0.85rem)',
                      color: '#666',
                      maxWidth: '300px',
                      lineHeight: '1.6'
                    }}>
                      Refundable upon return of vehicle in good condition
                    </div>
                  </div>
                </div>
              )}

              {/* Contact Info */}
              <div style={{
                padding: 'clamp(1.5rem, 3vw, 2rem)',
                background: 'rgba(199, 179, 129, 0.08)',
                border: '1px solid rgba(199, 179, 129, 0.2)',
                borderRadius: '12px',
                marginBottom: 'clamp(1.5rem, 3vw, 2rem)'
              }}>
                <h4 style={{
                  fontSize: 'clamp(1.1rem, 2vw, 1.3rem)',
                  color: '#C7B381',
                  marginBottom: 'clamp(0.8rem, 1.5vw, 1rem)',
                  fontWeight: '500'
                }}>
                  Ready to book this vehicle?
                </h4>
                <p style={{
                  color: '#B8B8B8',
                  fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                  lineHeight: '1.6',
                  marginBottom: 'clamp(1rem, 2vw, 1.5rem)'
                }}>
                  Contact us today to check availability and make a reservation
                </p>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                  gap: 'clamp(0.8rem, 1.5vw, 1rem)'
                }}>
                  <a
                    href={`tel:${PHONE_NUMBER}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      padding: 'clamp(0.9rem, 1.8vw, 1rem)',
                      background: '#4CAF50',
                      color: 'white',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      fontWeight: '600',
                      fontSize: 'clamp(0.9rem, 1.6vw, 0.95rem)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#5FBF6F'}
                    onMouseLeave={(e) => e.currentTarget.style.background = '#4CAF50'}
                  >
                    📞 Call Now
                  </a>
                  <a
                    href={`https://wa.me/${PHONE_NUMBER.replace(/[^0-9]/g, '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      padding: 'clamp(0.9rem, 1.8vw, 1rem)',
                      background: '#25D366',
                      color: 'white',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      fontWeight: '600',
                      fontSize: 'clamp(0.9rem, 1.6vw, 0.95rem)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#34E376'}
                    onMouseLeave={(e) => e.currentTarget.style.background = '#25D366'}
                  >
                    💬 WhatsApp
                  </a>
                </div>
              </div>

              {/* Close Button */}
              <button
                onClick={() => setShowRatesModal(false)}
                style={{
                  width: '100%',
                  padding: 'clamp(1rem, 2vw, 1.2rem)',
                  background: 'transparent',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.4)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: 'clamp(0.95rem, 1.7vw, 1rem)',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.1)';
                  e.currentTarget.style.borderColor = '#C7B381';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.4)';
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default HiringViewer;